// RESONATE_ANALYTICS_INSTRUMENTED
// Central analytics helper. Fires to GA4 (gtag) and PostHog if loaded.
// Safe to call before either lib finishes loading - both stub themselves.

import { trackRedditLead, trackMetaLead } from "@/components/TrackingPixels";

const isBrowser = () => typeof window !== "undefined";

export const trackEvent = (name, props = {}) => {
  if (!isBrowser()) return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, props);
    }
  } catch (e) { /* never break the UI for analytics */ }
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, props);
    }
  } catch (e) {}
  // Ad-platform conversions: every "Start free trial" CTA sitewide funnels
  // through trackEvent('cta_click', ...), so firing a "Lead" here reports the
  // conversion once, centrally, without touching each CTA component.
  try {
    if (name === "cta_click") {
      trackRedditLead({ location: props.location });
      trackMetaLead();
    }
  } catch (e) {}
};

// Fires a synthetic GA page_view and a PostHog section_view.
// Lets you build a section-by-section funnel in GA4 Funnel Exploration
// and PostHog Funnels using the same key.
export const trackSectionView = (sectionId, sectionName) => {
  if (!isBrowser()) return;
  const page_path = `/section/${sectionId}`;
  const page_title = sectionName ? `Resonate - ${sectionName}` : sectionId;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path,
        page_title,
        page_location: window.location.origin + page_path,
      });
    }
  } catch (e) {}
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture("section_view", {
        section_id: sectionId,
        section_name: sectionName,
        $current_url: window.location.origin + page_path,
      });
    }
  } catch (e) {}
};
